import FooterColumnComponent from './FooterColumnComponent'

export default FooterColumnComponent
